import React from 'react';
import { Send } from 'lucide-react';
import { useLeadForm } from '../LeadFormContext';
const steps = [{
  num: '1',
  title: 'Оставьте заявку',
  desc: 'Расскажите, для каких задач нужен трактор. Мы подберём модель и рассчитаем лизинг.'
}, {
  num: '2',
  title: 'Согласуем условия',
  desc: 'Подберём оптимальную программу лизинга или прямой покупки. Оформим документы.'
}, {
  num: '3',
  title: 'Доставка до места',
  desc: 'Доставим трактор прямо в ваше хозяйство. При предзаказе — бесплатно.'
}];
export function HowItWorks() {
  const {
    openForm
  } = useLeadForm();
  return <section className="bg-[#F5F7FA] px-5 py-14 md:px-12 lg:px-24" data-id="element-82">
      <div className="max-w-2xl mx-auto" data-id="element-83">
        <h2 className="font-heading font-bold text-[28px] md:text-[36px] text-[#0A1A3F] text-center mb-10" data-id="element-84">
          Как купить трактор
        </h2>

        <div className="space-y-0" data-id="element-85">
          {steps.map((step, i) => <div key={step.num} className="flex gap-4 md:gap-6" data-id="element-86">
              {/* Timeline */}
              <div className="flex flex-col items-center" data-id="element-87">
                <div className="w-10 h-10 rounded-full bg-[#228B22] text-white flex items-center justify-center font-heading font-bold text-base shrink-0" data-id="element-88">
                  {step.num}
                </div>
                {i < steps.length - 1 && <div className="w-0.5 bg-[#228B22]/25 flex-1 my-2" data-id="element-89" />}
              </div>
              {/* Content */}
              <div className={`pb-8 ${i === steps.length - 1 ? 'pb-0' : ''}`} data-id="element-90">
                <h3 className="font-heading font-bold text-base md:text-lg text-[#0A1A3F]" data-id="element-91">
                  {step.title}
                </h3>
                <p className="text-sm md:text-base text-gray-600 mt-1 leading-relaxed" data-id="element-92">
                  {step.desc}
                </p>
              </div>
            </div>)}
        </div>

        {/* CTA */}
        <button onClick={openForm} className="flex items-center justify-center gap-2.5 w-full bg-[#25D366] hover:bg-[#1da851] text-white font-heading font-bold text-lg min-h-[56px] rounded-2xl transition-colors mt-10 cursor-pointer" data-id="element-93">
          <Send className="w-5 h-5" data-id="element-94" />
          Оставить заявку
        </button>
      </div>
    </section>;
}